/* ===========================================================
   Captação do site público (landing + demo — ADR §38).
   A medição real do funil continua no Mixpanel (identifyLead + eventos em
   src/analytics, no chamador). Aqui, além disso, avisamos o time por e-mail
   via Pages Function (functions/api/*) → Resend. O envio é BEST-EFFORT e
   OTIMISTA: qualquer falha de rede é engolida e o submit segue como "ok"
   (a confirmação na tela e o identify no Mixpanel nunca dependem do e-mail).
   Sob `npm run dev` (Vite puro, sem Functions) o POST dá 404 — e tudo bem.
   =========================================================== */
import type { FeedbackInput, WaitlistInput } from "../shared";

/** Lead quente do fim da demo → e-mail (template "lucraa-waitlist"). */
export async function submitWaitlist(
  input: WaitlistInput,
  honeypot = "",
  origem = "",
): Promise<{ ok: boolean; error?: string }> {
  try {
    await fetch("/api/waitlist", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...input, honeypot, origem }),
    });
  } catch {
    // best-effort: a captação real é o Mixpanel; não bloqueia a confirmação.
  }
  return { ok: true };
}

/** Inscrição na newsletter (blog/conteúdo) → e-mail (template "lucraa-newsletter"). */
export async function submitNewsletter(
  email: string,
  honeypot = "",
  origem = "",
): Promise<{ ok: boolean; error?: string }> {
  try {
    await fetch("/api/newsletter", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, honeypot, origem }),
    });
  } catch {
    // best-effort (idem submitWaitlist).
  }
  return { ok: true };
}

export function submitFeedback(_input: FeedbackInput): Promise<{ ok: boolean; error?: string }> {
  return Promise.resolve({ ok: true });
}
